import { Button, ButtonProps } from '@nextui-org/react';
import styled from 'styled-components';
import { StyledComponent } from 'styled-components';

import { ThemeProp } from '../../../theme/Themes';

export interface IconButtonProps extends ButtonProps {
  width?: string;
  height?: string;
  $isFilled?: boolean;
  $focused?: boolean;
  $color?: string;
}

export const IconButton = styled(Button).attrs(({ $isFilled, ...rest }) => ({
  ...rest,
  $isFilled: $isFilled || false,
}))<IconButtonProps>`
  margin: 0;
  padding: 0;
  min-width: 0;
  font-size: 0;
  line-height: 0;
  width: ${(props: IconButtonProps) => props.width || '2.5rem'};
  height: ${(props: IconButtonProps) => props.height || '2.5rem'};
  border: 0;
  border-radius: 50%;
  background-color: ${(props: ThemeProp & IconButtonProps) =>
    props.$focused ? 'transparent' : props.theme.colors.black};

  &:hover {
    stroke: ${(props: ThemeProp & IconButtonProps) => props.$color || props.theme.colors.primary.c200};
    svg {
      stroke: ${(props: ThemeProp & IconButtonProps) => props.$color || props.theme.colors.primary.c200};
    }
  }

  stroke: ${(props: ThemeProp & IconButtonProps) => props.$color || props.theme.colors.greyscale.c050};
  svg {
    stroke: ${(props: ThemeProp & IconButtonProps) => props.$color || props.theme.colors.greyscale.c050};
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    background-color: transparent;
  }
` as StyledComponent<typeof Button, IconButtonProps>;

export default IconButton;
